import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'

export default class elasticApi {
  async searchResources(q, highlight) {
    let query = await import('./graphql/elastic/rsourceSearch.graphql')
    return (await getApolloClient()).query({
      query: gql`${query}`,
      variables: { q, highlight }
    })
      .then(this.searchResourcesCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  
  searchResourcesCallback(response) {
    let search = response.data.resourcesElastic
    return search
  }
  
  async resourcesElastic(q) {
    let query = await import('./graphql/elastic/resourcesElastic.graphql')
    return (await getApolloClient()).query({
      query: gql`${query}`,
      variables: { query: q }
    })
      .then(this.resourcesElasticCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  
  resourcesElasticCallback(response) {
    let search = response.data.resourcesElastic
    return search
  }

  async applicationElastic( payload ) {
    let text = payload.query,
      appType = payload.appType,
      conditions = payload.conditions,
      take = payload.take,
      skip = payload.skip,
      creatorIds = payload.creatorIds,
      creationDateFrom = payload.creationDateFrom,
      creationDateTo = payload.creationDateTo,
      statusIds = payload.statusIds,
      id = payload.id
    
    let query = await import('./graphql/elastic/applicationElastic.gql')
    return (await getApolloClient(null, null, true)).query({
      query: gql`${query}`,
      variables: { 
        query: text, 
        creatorIds, 
        creationDateFrom, 
        creationDateTo,
        statusIds, 
        id,
        conditions,
        take, 
        skip, 
        appType
      }
    })
      .then(this.applicationElasticCallback)
  }
  
  applicationElasticCallback(response) {
    let search = response.data.applicationElastic
    return search
  }
}